module.exports = __webpack_public_path__ + "img/list-ul.712ae182.svg";